<template>
  <div id="res">
    <loading />
    <Header />
    <Main :build="build" />
    <BnrArea />
    <spFootMenu />
    <Footer />
  </div>
</template>

<style src="../assets/css/house_list.css"></style>
<style src="../assets/css/style_result.css"></style>

<script>
import loading from "@/components/loading.vue";
import Header from "@/components/HeaderSelect.vue";
import Main from "@/components/Res.vue";
import BnrArea from "@/components/BnrArea.vue";
import Footer from "@/components/Footer.vue";
import spFootMenu from "@/components/spFootMenu.vue";

export default {
  name: "Result",
  components: {
    loading,
    Header,
    Main,
    BnrArea,
    Footer,
    spFootMenu
  },
  props: {
    build: String,
  },
};
</script>